var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rates-component',{attrs:{"account-id":_vm.accountId,"rates":_vm.ratesModule.rates,"loading":_vm.loading},on:{"remove":_vm.remove}})}
var staticRenderFns = []

export { render, staticRenderFns }